import { Pipe, PipeTransform } from '@angular/core';
import { KeyValue } from '@angular/common';

@Pipe({
  name: 'sortKeyValue'
})
export class SortKeyValuePipe implements PipeTransform {
  transform(value: KeyValue<string, any>[]): KeyValue<string, any>[] {
    return value.sort((a, b) => {
      const numA = parseInt(a.key.replace(/\D/g, ''), 10) || 0;
      const numB = parseInt(b.key.replace(/\D/g, ''), 10) || 0;
      return numA - numB;
    });
  }
}
